import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ClassroomViewModel } from '../../classroom.vm';
import CurrentLesson from './current-lesson';
import { VideoProgress } from './player/player';

export const CurrentLessonContainer = () => {
  const vm = useViewModel(ClassroomViewModel);
  const navigate = useNavigate();

  const onClose = () => {
    if (vm.comesFromStudyPlan) {
      navigate(`/`);
    } else {
      navigate(`/library`);
    }
  };

  const onVideoProgress = (videoProgress: VideoProgress) => {
    vm.recordVideoProgress(vm.currentVideo.guid, videoProgress.usage);
    vm.recordLessonProgress(
      vm.classroom?.course.guid,
      vm.currentVideo?.guid as string,
      videoProgress.usage,
      vm.student.guid,
    );
  };

  return (
    <>
      <CurrentLesson
        currentVideo={vm.currentVideo}
        currentLesson={vm.currentLesson}
        onClose={onClose}
        onVideoProgress={onVideoProgress}
      />
    </>
  );
};

export default observer(CurrentLessonContainer);
